import React, { useEffect, useState } from "react";
import "./social-share.m.css";

const SocialShare = ({ url, defaultText, btnStyle }) => {
  const [isOpen, setIsOpen] = useState(false);

  const shareLinks = {
    facebook: () =>
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    twitter: () =>
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,
    linkedin: () =>
      `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}`
  };

  const openPopup = (platform) => {
    const link = shareLinks[platform]();
    const width = 600;
    const height = 400;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    window.open(link, "_blank", `width=${width},height=${height},left=${left},top=${top}`);
    setIsOpen(false);
  };

  return (
    <div styleName={btnStyle === "big" ? "social-share" : ""}>
      {
        btnStyle == "big"
        ? (
          <button styleName="share-button" onClick={() => setIsOpen(!isOpen)}>
            <img src="/icons/share-icons.png" alt="Share" />
          </button>
        )
        :
          (
            <div onClick={() => setIsOpen(!isOpen)} style={{display: "flex"}}>
              <img alt="audio-logo" src="/icons/right-arrow.png"  styleName="custom-img-icon"/>
              <p>&nbsp;Jaa</p>
            </div>
        )
      }

      {isOpen && (
        <div styleName={`share-popup-${btnStyle}`}>
          <div styleName="share-static-text">
            Valitse minne haluat jakaa!
          </div>
          <div styleName="share-buttons">
            <a onClick={() => openPopup("facebook")}>
              <i class="ri-facebook-line"></i>
            </a>
            <a onClick={() => openPopup("twitter")}>
              <i class="ri-twitter-x-line"></i>
            </a>
            <a onClick={() => openPopup("linkedin")}>
              <i class="ri-linkedin-line"></i>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialShare;
